import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	changerButtonsDisabledForgeFields: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changerButtonsDisabledForgeFieldsIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	changerButtonsDisabledForgeFieldsIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	changerButtonsDisabledForgeFields: {
		id: 'issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields',
		defaultMessage: 'Some fields in this project and issue type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
	changerButtonsDisabledForgeFieldsIssueTermRefresh: {
		id: 'issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields-issue-term-refresh',
		defaultMessage: 'Some fields in this project and work type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
	changerButtonsDisabledForgeFieldsIssueTermRefreshGalaxia: {
		id: 'issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields-issue-term-refresh-galaxia',
		defaultMessage: 'Some fields in this space and work type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
});
export default messages;
